import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@mui/material';
import { DepthIcon } from '@icons/DepthIcon';
import { WorkflowIcon } from '@icons/WorkflowIcon';
import { withLogin } from '@hoc/withLogin';
import { Lnb } from '../../common/lnb';
import * as S from './WorkflowStyles';

export const Workflow = withLogin(() => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <S.Container>
      <Lnb
        menuItem={[
          {
            name: t('Workflow.menu.title'),
            icon: <WorkflowIcon width={20} height={20} color={theme.colors['ic-gray-main']} />,
            subMenu: [
              {
                name: t('Workflow.menu.list'),
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'management',
              },
            ],
          },
        ]}
      />
      <Outlet />
    </S.Container>
  );
});
